import React, { Component } from 'react'
import { observer, inject, Provider } from "mobx-react"
import overviewIcon from "app/styles/images/sp/overview-selected.svg"
import DataChart from "./containers/DataChart"
import DataTable from "./containers/DataTable"
import "./Index.scss"
import Store from "app/stores/ecs/dashboard"

@inject("entrance", "auth") @observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }
  render() {
    return (
      <Provider store={this.store}>
        <div className="ecs">
          <h2 className="page-title"><img alt="" src={overviewIcon} />总览</h2>
          <DataChart />
          <DataTable />
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/ecs/dashboard/index.js